import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeFirstNumberCommand extends BaseCommand {
  CommandName = "ChangeFirstNumber";
  Command: {
    Value: string | null;
    BookingItemTmpId: string;
  };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string, value: string | null) {
    super(sessionId, operationId);
    this.Command = { Value: value, BookingItemTmpId: bookingItemTmpId };
  }
}
